import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'

import { useWindowDimensions } from 'react-native'
import { Container } from '../../../components/Container'
import { NewTable } from '../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../data/store'
import { dateFormatter, DateFormatTypes, MessageTypes } from '../../../utils'
import { checker1HeaderTitles, getCustomColumnWidth } from '../MyOnboardedEntityQueue'
import { CheckerHeader } from '../OnboardEntity/comps/CheckerHeader'
import { FiltersModal } from '../OnboardEntity/comps/FiltersModal'
const CheckerQueue = ({ route: { name } }: any) => {
  console.log('Checker1Queue props', name) //checker1Queue
  const { fetchGlobalEntityQueue, pagination, selectedDateInfo, setMessage } = useStores((store) => ({
    fetchGlobalEntityQueue: store.entityOnboarding.fetchGlobalEntityQueue,
    pagination: store.pagination,
    selectedDateInfo: store.selectedDateInfo,
    setMessage: store.message.setMessage,
  }))

  const [lazyFetchEntityOnBoardingList, entityOnBoardingListHandler] = useLazyApiData(fetchGlobalEntityQueue)
  const navigation: any = useNavigation()
  const [filterVisible, setFilterVisible] = useState(false)
  const [selectedFilterData, setSelectedFilterData] = useState(CHEKERS_KEY_MAAPING[name]?.filterInitialValue)
  const [searchByEntityIdInfo, setSearchByEntityIdInfo] = useState<any>({})
  useEffect(() => {
    const initialSelectedFilterData =
      JSON.parse(localStorage.getItem(name + '-filterData')) ?? CHEKERS_KEY_MAAPING[name]?.filterInitialValue
    setSelectedFilterData(initialSelectedFilterData)
  }, [])

  const parseFilterData = useCallback((filterData) => {
    return Object.keys(filterData).reduce(
      (acc, item) => ({
        ...acc,
        ...(item !== 'startDateOrder' && { [item]: filterData?.[item]?.map((data) => data?.key) }),
        ...(item === 'startDateOrder' && { [item]: filterData?.[item]?.[0]?.key }),
      }),
      {},
    )
  }, [])

  useEffect(() => {
    if (entityOnBoardingListHandler?.state === 'fulfilled' && searchByEntityIdInfo?.applicationId) {
      setSearchByEntityIdInfo({ ...searchByEntityIdInfo, showCross: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityOnBoardingListHandler?.state])

  const fetchGlobalEntityQueueAsync = useCallback(
    (formattedFilteredData, extraReqParams = {}) => {
      lazyFetchEntityOnBoardingList({
        applicationState: [CHEKERS_KEY_MAAPING[name]?.applicationState],
        pageNumber: pagination?.number - 1,
        pageSize: 10,
        startDate: dateFormatter(selectedDateInfo?.fromDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
        endDate: dateFormatter(selectedDateInfo?.toDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
        ...parseFilterData(formattedFilteredData),
        ...extraReqParams,
      })
    },
    [
      lazyFetchEntityOnBoardingList,
      name,
      pagination?.number,
      parseFilterData,
      selectedDateInfo?.fromDate,
      selectedDateInfo?.toDate,
    ],
  )

  const onApplyFiter = useCallback(
    (selectedFilter: any) => {
      localStorage.setItem(name + '-filterData', JSON.stringify(selectedFilter))
      setSelectedFilterData(selectedFilter)
      fetchGlobalEntityQueueAsync(selectedFilter, { applicationId: searchByEntityIdInfo?.applicationId })
    },
    [fetchGlobalEntityQueueAsync, searchByEntityIdInfo?.applicationId],
  )

  useEffect(() => {
    fetchGlobalEntityQueueAsync(selectedFilterData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { width } = useWindowDimensions()

  console.log('selectedFilterData', selectedFilterData)

  const onRowItemPress = useCallback(
    (item: any) => {
      if (!item?.taskInstanceId) {
        setMessage('Application under progress, please try after some time or refresh.', MessageTypes.ERROR)
      } else {
        navigation.navigate('checkerDetails', { item: item, type: name })
      }
    },
    [name, navigation, setMessage],
  )

  const onReload = useCallback(
    () => fetchGlobalEntityQueueAsync(selectedFilterData, { applicationId: searchByEntityIdInfo?.applicationId }),
    [fetchGlobalEntityQueueAsync, searchByEntityIdInfo?.applicationId, selectedFilterData],
  )

  return (
    <Box {...styles.container}>
      <CheckerHeader
        title={CHEKERS_KEY_MAAPING[name]?.title}
        fetchDataOnChange={() =>
          fetchGlobalEntityQueueAsync(selectedFilterData, { applicationId: searchByEntityIdInfo?.applicationId })
        }
        filterVisible={filterVisible}
        setFilterVisible={setFilterVisible}
        filterApplied={undefined}
        exportFile={(data) => {
          console.log('exportFile', data)
        }}
        onSearchByEntityIdClick={(applicationId) => {
          setSearchByEntityIdInfo({ ...searchByEntityIdInfo, applicationId, showCross: false })
          fetchGlobalEntityQueueAsync(selectedFilterData, { applicationId })
        }}
        showSearchByCrossButton={searchByEntityIdInfo?.showCross}
        showSearchByLoader={entityOnBoardingListHandler.state === 'pending'}
        showRefresh={true}
        onRefresh={onReload}
        showDownloadButton={['checker1Queue', 'checker2Queue'].includes(name)}
        selectedFilterData={{
          jobType: CHEKERS_KEY_MAAPING[name]?.jobType,
          checkerFilter: {
            ...parseFilterData(selectedFilterData),
            ...(searchByEntityIdInfo?.applicationId && { applicationId: searchByEntityIdInfo?.applicationId }),
            startDate: dateFormatter(selectedDateInfo?.fromDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
            endDate: dateFormatter(selectedDateInfo?.toDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
            requestType: ['NEW_PROFILE'],
          },
        }}
      />
      <Container
        isLoading={entityOnBoardingListHandler?.state === 'pending'}
        errorMessage={entityOnBoardingListHandler?.data?.message}
        emptyMessage={
          entityOnBoardingListHandler?.state === 'fulfilled' &&
          entityOnBoardingListHandler?.data?.length === 0 &&
          'No Data Found'
        }
        onRetry={onReload}>
        <NewTable
          data={entityOnBoardingListHandler?.data ?? []}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={checker1HeaderTitles}
          onRowClick={onRowItemPress}
          onRetry={onReload}
        />
      </Container>
      <FiltersModal
        show={filterVisible}
        onDismiss={() => setFilterVisible(false)}
        initialValue={selectedFilterData}
        data={CHEKERS_KEY_MAAPING[name]?.filterData}
        onApplyFiter={onApplyFiter}
        onReset={() => onApplyFiter(CHEKERS_KEY_MAAPING[name]?.filterInitialValue)}
      />
    </Box>
  )
}

export default CheckerQueue

const styles = {
  container: {
    h: '100%',
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
  } as BoxProps,
}

const CHECKER_1_FILTER_DATA = [
  {
    labelKey: 'requestType',
    labelDescription: 'By Request Type',
    checkBoxItems: [
      {
        key: 'NEW_PROFILE',
        description: 'New Merchant',
      },
      {
        key: 'UPDATE_PROFILE',
        description: 'Merchant Update',
      },
      {
        key: 'BULK_TERMINAL_ADD',
        description: 'Bulk Terminal Add',
      },
      {
        key: 'RISK_COMMENT_ONLY',
        description: 'RISK_COMMENT_ONLY',
      },
    ],
  },
  {
    labelKey: 'startDateOrder',
    labelDescription: 'Sort By',
    singleSelection: true,
    defaultSelected: 'Desc',
    checkBoxItems: [
      {
        key: 'Asc',
        description: 'Ascending',
      },
      {
        key: 'Desc',
        description: 'Descending',
      },
    ],
  },
]

const CHECKER_2_FILTER_DATA = [
  {
    labelKey: 'applicationState',
    labelDescription: 'By Status',
    checkBoxItems: [
      {
        key: 'OPS_CHECKER_TWO',
        description: 'OPS_CHECKER_TWO',
      },
      {
        key: 'RISK_APPROVED',
        description: 'RISK_APPROVED',
      },
    ],
  },
  {
    labelKey: 'requestType',
    labelDescription: 'By Request Type',
    checkBoxItems: [
      {
        key: 'NEW_PROFILE',
        description: 'New Merchant',
      },
      {
        key: 'UPDATE_PROFILE',
        description: 'Merchant Update',
      },
      {
        key: 'BULK_TERMINAL_ADD',
        description: 'Bulk Terminal Add',
      },
      {
        key: 'RISK_COMMENT_ONLY',
        description: 'RISK_COMMENT_ONLY',
      },
    ],
  },
  {
    labelKey: 'startDateOrder',
    labelDescription: 'Sort By',
    singleSelection: true,
    defaultSelected: 'Desc',
    checkBoxItems: [
      {
        key: 'Asc',
        description: 'Ascending',
      },
      {
        key: 'Desc',
        description: 'Descending',
      },
    ],
  },
]

const RISK_CHECKER_FILTER_DATA = [
  {
    labelKey: 'requestType',
    labelDescription: 'By Request Type',
    checkBoxItems: [
      {
        key: 'NEW_PROFILE',
        description: 'New Merchant',
      },
      {
        key: 'UPDATE_PROFILE',
        description: 'Merchant Update',
      },
      {
        key: 'RISK_UPDATE_PROFILE',
        description: 'RISK_UPDATE_PROFILE',
      },
      {
        key: 'RISK_COMMENT_ONLY',
        description: 'RISK_COMMENT_ONLY',
      },
    ],
  },
  {
    labelKey: 'startDateOrder',
    labelDescription: 'Sort By',
    singleSelection: true,
    defaultSelected: 'Desc',
    checkBoxItems: [
      {
        key: 'Asc',
        description: 'Ascending',
      },
      {
        key: 'Desc',
        description: 'Descending',
      },
    ],
  },
]

const RISK_MAKER_FILTER_DATA = [
  {
    labelKey: 'requestType',
    labelDescription: 'By Request Type',
    checkBoxItems: [
      {
        key: 'NEW_PROFILE',
        description: 'New Merchant',
      },
      {
        key: 'UPDATE_PROFILE',
        description: 'Merchant Update',
      },
      {
        key: 'RISK_UPDATE_PROFILE',
        description: 'RISK_UPDATE_PROFILE',
      },
      {
        key: 'RISK_COMMENT_ONLY',
        description: 'RISK_COMMENT_ONLY',
      },
    ],
  },
  {
    labelKey: 'startDateOrder',
    labelDescription: 'Sort By',
    singleSelection: true,
    defaultSelected: 'Desc',
    checkBoxItems: [
      {
        key: 'Asc',
        description: 'Ascending',
      },
      {
        key: 'Desc',
        description: 'Descending',
      },
    ],
  },
]

const getIntialValue = (data) =>
  data.reduce((acc, category) => {
    acc[category.labelKey] = category.checkBoxItems
      .map((item) => ({
        ...item,
        isChecked:
          (category?.singleSelection && item?.key === category?.defaultSelected) || !category?.singleSelection
            ? true
            : false,
      }))
      .filter((item) => item?.isChecked)
    return acc
  }, {})

const CHEKERS_KEY_MAAPING = {
  checker1Queue: {
    applicationState: 'OPS_CHECKER_ONE',
    title: 'Checker1 Queue',
    filterData: CHECKER_1_FILTER_DATA,
    filterInitialValue: getIntialValue(CHECKER_1_FILTER_DATA),
    jobType: 'CHECKER_ONE_CLAIM_EXPORT',
  },
  checker2Queue: {
    applicationState: 'OPS_CHECKER_TWO',
    title: 'Checker2 Queue',
    filterData: CHECKER_2_FILTER_DATA,
    filterInitialValue: getIntialValue(CHECKER_2_FILTER_DATA),
    jobType: 'CHECKER_TWO_CLAIM_EXPORT',
  },
  riskCheckerQueue: {
    applicationState: 'RISK_CHECKER_ONE',
    title: 'Risk Checker Queue',
    filterData: RISK_CHECKER_FILTER_DATA,
    filterInitialValue: getIntialValue(RISK_CHECKER_FILTER_DATA),
  },
  riskMakerQueue: {
    applicationState: 'RISK_MAKER',
    title: 'Risk Maker Queue',
    filterData: RISK_MAKER_FILTER_DATA,
    filterInitialValue: getIntialValue(RISK_MAKER_FILTER_DATA),
  },
}
